"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISNUMBER = void 0;
exports.ISNUMBER = {
    alias: 'ENUM',
    description: 'Verifica se o valor é convertível para número',
    arg_names: ['valor'],
    args_description: ['Valor que pode ou não ser numérico'],
};
